<script lang="ts" setup>
import LanguageDropdown from './LanguageDropdown.vue'
import LiveChat from './LiveChat.vue'
</script>

<template>
    <footer>
        <div class="footer-small">
            <LiveChat />
            <LanguageDropdown />
        </div>
    </footer>
</template>
